export default __webpack_public_path__ + "src/images/packages/kumbu-kumbu-lodge/c35905227d242d5aec0a4f7610f96287-2.jpg";